import { render, staticRenderFns } from "./OddOneOutCard.vue?vue&type=template&id=383e8554&scoped=true"
import script from "./OddOneOutCard.vue?vue&type=script&lang=js"
export * from "./OddOneOutCard.vue?vue&type=script&lang=js"
import style0 from "./OddOneOutCard.vue?vue&type=style&index=0&id=383e8554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e8554",
  null
  
)

export default component.exports